import React, { useEffect, useState } from "react"
import withRouter from "components/Common/withRouter"
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"
import { Link, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom"
import Breadcrumb from "components/Common/Breadcrumb"
import toast from "react-hot-toast" 
import { addNewBlog, getViewBlog, updateBlog, updateHomePage, viewHomePage } from "helpers/fakebackend_helper"
import CustomTamilInput from "components/VerticalLayout/CustomTamilInput"
import ImagePopup from "pages/Home-Page/ImagePopup"
import { CKEditor } from "@ckeditor/ckeditor5-react"
import ClassicEditor from "@ckeditor/ckeditor5-build-classic"

const BlogForm = () => {
  const [activeTab, setactiveTab] = useState(1)
  const [activeTabVartical, setoggleTabVertical] = useState(1)

     const { slug } = useParams();
     const [searchParams, setSearchParams]=useSearchParams()

  const [passedSteps, setPassedSteps] = useState([1])
  const [passedStepsVertical, setPassedStepsVertical] = useState([1])
  const [show, setshow] = useState([true, true, true, true])
  const [navId, setNavId] = useState()
  const [slugs, setSlugs] = useState()
  const { state } = useLocation()
  const [btn, setBtn] = useState(false)
  const [showPopup, setShowPopup] = useState(false)
  const handleClose = () => setShowPopup(false)
  const [image_path, setImage_path] = useState("")
  const navigate = useNavigate()


  console.log('slug', searchParams?.get('slug'));
  

  const [tab1, setTab1] = useState({
    blog_image: "",
    eng_title: "",
    tamil_title: "",
    eng_desc: "",
    tamil_desc: "",
    eng_blog_by : "",
    tamil_blog_by  :"",
    eng_intro : "",
    tamil_intro: ""
  })

  const [tab2, setTab2] = useState({
    eng_title: "",
    tamil_title: "",
    image_path: "",
    points:[
      {
        eng_title: "",
        tamil_title: "",
      }  
    ],
  })

  const [tab3, setTab3] = useState({
    eng_title: "",
    tamil_title: "",
    image_path: "",
    points: [
        {
         eng_title:'',
         tamil_title: ""
        }

    ],
  })

  const [tab4, setTab4] = useState({
    eng_title: "",
    image_path: "",
    tamil_title: "",
    eng_intro:"",
    tamil_intro : "",
    points: [
        {
         eng_title:'',
         tamil_title: ""
        }

    ],  
  })

  const handleTab1Change = e => {
    const { name, value } = e.target
    setTab1(p => ({ ...p, [name]: value }))
  }

  const handleTab2Change = e => {
    const { name, value } = e.target
    setTab2(p => ({ ...p, [name]: value }))
  }

  const handleTab3Change = e => {
    const { name, value } = e.target
    setTab3(p => ({ ...p, [name]: value }))
  }

  const handleTab4Change = e => {
    const { name, value } = e.target
    setTab4(p => ({ ...p, [name]: value }))
  }

  const onAddFormRow = () => {
    const newRow = {
      id: Math.floor(Math.random() * (30 - 20)) + 20,
      emp_eng_title: "",
      emp_tamil_title: "",
      emp_eng_sub_title: "",
      emp_tamil_tsub_title: "",
      image_path: "",
      redirect_url: "",
    }
    setTab2({ ...tab2, empowering_lists: [...tab2.empowering_lists, newRow] })
  }

  const onAddFormRow2 = () => {
    const newRow = {
      id: Math.floor(Math.random() * (30 - 20)) + 20,
      comm_eng_title: "",
      comm_tamil_title: "",
      comm_eng_sub_title: "",
      comm_tamil_tsub_title: "",
    }
    setTab3({ ...tab3, commitment_lists: [...tab3.commitment_lists, newRow] })
  }

  const onAddFormRow3 = () => {
    const newRow = {
      id: Math.floor(Math.random() * (30 - 20)) + 20,
      eng_title: "",
      tamil_title: "",
      eng_description: "",
      tamil_description: "",
      eng_schools: "",
      tamil_schools: "",
      eng_reach: "",
      tamil_reach: "",
      image_path: "",
    }
    setTab4({ ...tab4, programs: [...tab4.programs, newRow] })
  }

  const onDeleteFormRow = id => {
    const updatedRows = tab2.empowering_lists.filter(row => row.id !== id)
    setTab2({ ...tab2, empowering_lists: updatedRows })
  }

  const onDeleteFormRow2 = id => {
    const updatedRows = tab3.commitment_lists.filter(row => row.id !== id)
    setTab3({ ...tab3, commitment_lists: updatedRows })
  }

  const onDeleteFormRow3 = id => {
    const updatedRows = tab4.programs.filter(row => row.id !== id)
    setTab4({ ...tab4, programs: updatedRows })
  }

  const handleInputChange = (id, name, value) => {
    const updatedRows = tab2.empowering_lists.map(row => {
      if (row.id === id) {
        return { ...row, [name]: value }
      }
      return row
    })
    setTab2({ ...tab2, empowering_lists: updatedRows })
  }

  const handleInputChange2 = (id, name, value) => {
    const updatedRows = tab3.commitment_lists.map(row => {
      if (row.id === id) {
        return { ...row, [name]: value }
      }
      return row
    })
    setTab3({ ...tab3, commitment_lists: updatedRows })
  }

  const handleInputChange3 = (id, name, value) => {
    const updatedRows = tab4.programs.map(row => {
      if (row.id === id) {
        return { ...row, [name]: value }
      }
      return row
    })
    setTab4({ ...tab4, programs: updatedRows })
  }

  const handleTab1Verify = () => {
    if (
      tab1.tamil_title != "" &&
      tab1.eng_title != "" &&
      tab1.eng_blog_by != "" &&
      tab1.tamil_blog_by != "" &&
      tab1.tamil_desc != "" &&
      tab1.eng_desc != "" &&
      tab1.eng_intro != "" &&
      tab1.tamil_intro != ""
    ) {
      return true
    } else {
      toast.error("Enter All Required Feilds!")
      return false
    }
  }

  const handleTab2Verify = () => {
    if (
      tab2.eng_title != "" &&
      tab2.tamil_title != ""
    ) {
      return true
    } else if(tab2.points?.length == 0) {
        toast.error("Enter Points Required Feilds!")
        return false
    } else{
      toast.error("Enter All Required Feilds!")
      return false
    }
  }

  const handleTab3Verify = () => {
    if (
        tab3.eng_title != "" &&
        tab3.tamil_title != ""
      ) {
        return true
      } else if(tab3.points?.length == 0) {
          toast.error("Enter Points Required Feilds!")
          return false
      } else{
        toast.error("Enter All Required Feilds!")
        return false
      }
  
  }

  const handleTab4Verify = () => {
    if (
        tab4.eng_title != "" &&
        tab4.tamil_title != ""&&
        tab4.eng_intro != "" &&
        tab4.tamil_intro != ""
      ) {
        return true
      } else if(tab4.points?.length == 0) {
          toast.error("Enter Points Required Feilds!")
          return false
      } else{
        toast.error("Enter All Required Feilds!")
        return false
      }
  
  }

  function toggleTab(tab) {
    if (activeTab !== tab) {
      var modifiedSteps = [...passedSteps, tab]
      if (tab >= 1 && tab <= 4) {
        setactiveTab(tab)
        setPassedSteps(modifiedSteps)
      }
    }
  }

  function toggleTabVertical(tab) {
    if (activeTabVartical !== tab) {
      var modifiedSteps = [...passedStepsVertical, tab]

      if (tab >= 1 && tab <= 4) {
        setoggleTabVertical(tab)
        setPassedStepsVertical(modifiedSteps)
      }
    }
  }

  const [isLoading, setisLoading] = useState(false)

  const getBlogDetails = navigation_id => {
    let payloads = new FormData()
    payloads.append('blog_id', searchParams?.get('slug'))
    let payload = {
        blog_id: searchParams?.get('slug')
    }
    getViewBlog(payload)
      .then(res => {
        let data = res?.data
        
        if (data?.blog_id) {
            let obj = {
                blog_image: data?.blog_image,
                eng_title: data?.eng_title,
                tamil_title: data?.tamil_title,
                eng_desc: data?.eng_description,
                tamil_desc: data?.tamil_description,
                eng_blog_by: data?.eng_blog_by,
                tamil_blog_by:data?.tamil_blog_by,
                eng_intro: data?.intro_json?.eng_intro,
                tamil_intro: data?.intro_json?.tamil_intro,
            }
          setTab1(obj)
        }
        // TAB 2
        if (data?.right_image_json) {
            let obj = {
                ...data?.right_image_json,
                points:[]
            }
            let arr = Object.values(data?.right_image_json?.points)
            obj.points = arr
          setTab2(obj)
        }

        // TAB 3
        if (data?.left_image_json) {
            let obj = {
                ...data?.left_image_json,
                points:[]
            }
            let arr = Object.values(data?.left_image_json?.points)
            obj.points = arr
          setTab3(obj)
        }

        // tab 4
        if (data?.center_image_json) {
            let obj = {
                ...data?.center_image_json,
                points:[],    
                eng_intro:data?.conclusion_json?.eng_intro,
                tamil_intro : data?.conclusion_json?.tamil_intro,
            }
            let arr = Object.values(data?.center_image_json?.points)
            obj.points = arr
          setTab4(obj)
        }
        
      })
      .catch(err => {
        console.log("err", err)
      })
  }

  useEffect(() => {
    if (state?.data?.id) {
      setNavId(state?.data?.id)
      getBlogDetails(searchParams?.get('slug'))
      setSlugs(state?.data?.slug)
    }

    if(searchParams?.get('slug')){
      getBlogDetails()
  }

  }, [state])

  // console.log('statestatestate', slug);

  const handleSubmitForm = () => {
    var formData = new FormData()

    // formData.append("navigation_id", navId)
    if(searchParams?.get('slug')){
        formData.append('blog_id', searchParams?.get('slug'))
    }

    // tab 1
    formData.append(`eng_title`, tab1?.eng_title)
    formData.append(`tamil_title`, tab1?.tamil_title)
    formData.append(`eng_description`, tab1?.eng_desc)
    formData.append(`tamil_description`, tab1?.tamil_desc)
    formData.append(`eng_blog_by`, tab1?.eng_blog_by)
    formData.append(`tamil_blog_by`, tab1?.tamil_blog_by)
    formData.append(`blog_image`, tab1?.blog_image)
    formData.append(`intro_json[eng_intro]`, tab1?.eng_intro)
    formData.append(`intro_json[tamil_intro]`, tab1?.tamil_title)
    formData.append(`social_links_json[facebook]`, 'sample')
    formData.append(`social_links_json[Insta]`, 'sample')
    formData.append(`social_links_json[youtube]`, 'sample')
    formData.append(`social_links_json[twitter]`, 'sample')

    // tab 2
    formData.append(`right_image_json[eng_title]`, tab2?.eng_title)
    formData.append(`right_image_json[tamil_title]`, tab2?.tamil_title)
    formData.append(`right_image_json[image_path]`, tab2?.image_path)
    tab2.points.map((data,i) =>{
        formData.append(`right_image_json[points][${i}][eng_title]`, data.eng_title)
        formData.append(`right_image_json[points][${i}][tamil_title]`, data.tamil_title)
    })

    // tab 3
    formData.append(`left_image_json[eng_title]`, tab3?.eng_title)
    formData.append(`left_image_json[tamil_title]`, tab3?.tamil_title)
    formData.append(`left_image_json[image_path]`, tab3?.image_path)
    tab3.points.map((data,i) =>{
        formData.append(`left_image_json[points][${i}][eng_title]`, data.eng_title)
        formData.append(`left_image_json[points][${i}][tamil_title]`, data.tamil_title)
    }) 

    // tab 4
    formData.append(`center_image_json[eng_title]`, tab4?.eng_title)
    formData.append(`center_image_json[tamil_title]`, tab4?.tamil_title)
    formData.append(`center_image_json[image_path]`, tab4?.image_path)
    formData.append(`conclusion_json[eng_intro]`, tab4?.eng_intro)
    formData.append(`conclusion_json[tamil_intro]`, tab4?.tamil_intro)
    tab4.points.map((data,i) =>{
        formData.append(`center_image_json[points][${i}][eng_title]`, data.eng_title)
        formData.append(`center_image_json[points][${i}][tamil_title]`, data.tamil_title)
    }) 

    if(searchParams?.get('slug')){
        setisLoading(true)
        updateBlog(formData)
          .then(res => {
            setisLoading(false)
            if (res?.success) {
              toast.success("Added Success")
              navigate('/blog')
            } else {
              toast.error(res?.message ?? "somthing went wrong!")
            }
          })
          .catch(err => {
            setisLoading(false)
            toast.error(err.message)
          })
    }else {
        setisLoading(true)
        addNewBlog(formData)
          .then(res => {
            setisLoading(false)
            if (res?.success) {
              toast.success("Added Success")
              navigate('/blog')
            //   getBlogDetails(res?.data?.slug ?? slug)
            } else {
              toast.error(res?.message ?? "somthing went wrong!")
            }
          })
          .catch(err => {
            setisLoading(false)
            toast.error(err.message)
          })
    }

  }

  const getImg = image_ => {
    setImage_path(image_)
    setShowPopup(true)
  }

  return (
    <>
      <ImagePopup
        showPopup={showPopup}
        handleClose={handleClose}
        image_path={image_path}
      />
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            title="Dashboard"
            breadcrumbItem={'Create Blog'}
          />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {/* <h4 className="card-title mb-4">Home</h4> */}
                  <div className="wizard clearfix">
                    <div className="steps clearfix">
                      <ul>
                        <NavItem
                          className={classnames({ current: activeTab === 1 })}
                        >
                          <NavLink
                            className={classnames({ current: activeTab === 1 })}
                            onClick={() => {
                              setactiveTab(1)
                            }}
                            disabled={!(passedSteps || []).includes(1)}
                          >
                            <span className="text-truncate">
                              <span className="number">1.</span>
                              BLOG HEADER
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 2 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 2 })}
                            onClick={() => {
                              setactiveTab(2)
                            }}
                            disabled={!(passedSteps || []).includes(2)}
                          >
                            <span className="text-truncate">
                              <span className="number">2.</span>
                              RIGHT IMAGES
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 3 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 3 })}
                            onClick={() => {
                              setactiveTab(3)
                            }}
                            disabled={!(passedSteps || []).includes(3)}
                          >
                            <span className="text-truncate">
                              <span className="number">3.</span>
                              LEFT IMAGES
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem
                          className={classnames({ current: activeTab === 4 })}
                        >
                          <NavLink
                            className={classnames({ active: activeTab === 4 })}
                            onClick={() => {
                              setactiveTab(4)
                            }}
                            disabled={!(passedSteps || []).includes(4)}
                          >
                            <span className="text-truncate">
                              <span className="number">4.</span> CENTER IMAGE
                            </span>
                          </NavLink>
                        </NavItem>
                      </ul>
                    </div>

                    <div className="content clearfix">
                      <TabContent activeTab={activeTab} className="body">
                        <TabPane tabId={1}>
                          {/* <div className="d-flex justify-content-end w-100">
                                <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                    setshow((p) => {
                                        const h = [...p];
                                        h[0] = !h[0];
                                        return h;
                                    })
                                }}>{show[0] ? "Show" : 'Hidden'}</button>
                            </div> */}
                          <Form>
                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-firstname-input1">
                                    English Title{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    type="text"
                                    name="eng_title"
                                    onChange={handleTab1Change}
                                    value={tab1?.eng_title}
                                    className="form-control"
                                    id="basicpill-firstname-input1"
                                    placeholder="Enter English Title"
                                  />
                                </div>
                              </Col>

                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-lastname-input2">
                                    Tamil Title{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <CustomTamilInput
                                    value={tab1.tamil_title}
                                    setValue={e =>
                                      setTab1(p => ({ ...p, tamil_title: e }))
                                    }
                                  />
                                </div>
                              </Col>
                            </Row> 

                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-firstname-input1">
                                     English Intro{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    type="text"
                                    name="eng_intro"
                                    onChange={handleTab1Change}
                                    value={tab1?.eng_intro}
                                    className="form-control"
                                    id="basicpill-firstname-input1"
                                    placeholder="Enter English Title"
                                  />
                                </div>
                              </Col>

                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-lastname-input2">
                                     Tamil Intro{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <CustomTamilInput
                                    value={tab1.tamil_intro}
                                    setValue={e =>
                                      setTab1(p => ({ ...p, tamil_intro: e }))
                                    }
                                  />
                                </div>
                              </Col>
                            </Row> 

                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-firstname-input1">
                                     English Blog by{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    type="text"
                                    name="eng_blog_by"
                                    onChange={handleTab1Change}
                                    value={tab1?.eng_blog_by}
                                    className="form-control"
                                    id="basicpill-firstname-input1"
                                    placeholder="Enter English Title"
                                  />
                                </div>
                              </Col>

                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="basicpill-lastname-input2">
                                    Tamil Blog By{" "}
                                    <span className="text-danger">*</span>
                                  </Label>
                                  <CustomTamilInput
                                    value={tab1.tamil_blog_by}
                                    setValue={e =>
                                      setTab1(p => ({ ...p, tamil_blog_by: e }))
                                    }
                                  />
                                </div>
                              </Col>
                            </Row> 

                            <Row>
                                <Col lg="6">
                                    <div className="mb-3">
                                    <Label for="basicpill-suib-input7">
                                        English Desc{" "}
                                        <span className="text-danger">*</span>
                                    </Label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={tab1.eng_desc}
                                        onChange={(event, editor) => {
                                        const data = editor.getData()
                                        setTab1(p => ({ ...p, eng_desc: data }))
                                        }}
                                        config={{
                                        toolbar: {
                                            items: [
                                            "undo",
                                            "redo",
                                            "|",
                                            "bold",
                                            "italic",
                                            "|",
                                            "numberedList", 
                                            "bulletedList", 
                                            ],
                                            maxWordCount: 10,
                                        },
                                        }}
                                    />
                                    </div>
                                </Col>
                                <Col lg="6">
                                    <div className="mb-3">
                                    <Label for="basicpill-ygksd-input8">
                                        Tamil Desc{" "}
                                        <span className="text-danger">*</span>
                                    </Label>
                                    <CKEditor
                                        editor={ClassicEditor}
                                        data={tab1.tamil_desc}
                                        onChange={(event, editor) => {
                                        const data = editor.getData()
                                        setTab1(p => ({
                                            ...p,
                                            tamil_desc: data,
                                        }))
                                        }}
                                        config={{
                                        toolbar: {
                                            items: [
                                            "undo",
                                            "redo",
                                            "|",
                                            "bold",
                                            "italic",
                                            "|",
                                            "numberedList", 
                                            "bulletedList",
                                            ],
                                            maxWordCount: 10,
                                        },

                                        }}
                                    />
                                    </div>
                                </Col>
                            </Row> 

                            <Row>
                              <Col lg="6">
                                <div className="mb-3">
                                  <Label for="imag">
                                    Blog Image
                                   <span className="text-danger">*</span>
                                  </Label>
                                  <Input
                                    type="file"
                                    onChange={e =>
                                      setTab1(p => ({
                                        ...p,
                                        blog_image: e.target.files[0],
                                      }))
                                    }
                                    className="form-control"
                                    id="imag"
                                  />
                                </div>

                                {tab1?.blog_image && (
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => {
                                      getImg(tab1?.blog_image)
                                    }}
                                  >
                                    Preview
                                  </button>
                                )}
                              </Col>
                            </Row>

                          </Form>
                        </TabPane>

                        <TabPane tabId={2}>
                          <div>
                            {/* <div className="d-flex justify-content-end w-100">
                                    <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                        setshow((p) => {
                                            const h = [...p];
                                            h[1] = !h[1];
                                            return h;
                                        })
                                    }}>{show[1] ? "Show" : 'Hidden'}</button>
                                </div> */}
                            <Form>
                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-eng-input5">
                                      English Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      type="text"
                                      name="eng_title"
                                      onChange={handleTab2Change}
                                      className="form-control"
                                      id="basicpill-eng-input5"
                                      placeholder="Enter English Title."
                                      value={tab2?.eng_title}
                                    />
                                  </div>
                                </Col>

                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-hgsd-input6">
                                      Tamil Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <CustomTamilInput
                                      value={tab2.tamil_title}
                                      name={"tamil_title"}
                                      setValue={e =>
                                        setTab2(p => ({ ...p, tamil_title: e }))
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col lg="6">
                                    <div className="mb-3">
                                    <Label for="imag">
                                        Image
                                    <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                        type="file"
                                        onChange={e =>
                                        setTab2(p => ({
                                            ...p,
                                            image_path: e.target.files[0],
                                        }))
                                        }
                                        className="form-control"
                                        id="imag"
                                    />
                                    </div>

                                    {tab2?.image_path && (
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => {
                                        getImg(tab2?.image_path)
                                        }}
                                    >
                                        Preview
                                    </button>
                                    )}
                                </Col>
                              </Row>

                              <h6 className="mb-3 mt-3 card-title">POINTS</h6>
                              {
                                tab2.points?.map((formrow, key) =>  (
                                 <Row key={key}>
                                    <Col lg="5">
                                      <div className="mb-3">
                                        <Label for="basicpill-eng-input5">
                                          English Title{" "}
                                          <span className="text-danger">*</span>
                                        </Label>
                                        <Input
                                          type="text"
                                          name="eng_title"
                                          onChange={(e) =>{
                                            setTab2({...tab2,points:tab2.points.map((d, l) => {
                                                if(l == key){
                                                   return {...d, eng_title:e.target.value};
                                                }
                                                return d;
                                            })})
                                          }}
                                          className="form-control"
                                          id="basicpill-eng-input5"
                                          placeholder="Enter English Title."
                                          value={formrow?.eng_title}
                                        />
                                      </div>
                                    </Col>
    
                                    <Col lg="5">
                                      <div className="mb-3">
                                        <Label for="basicpill-hgsd-input6">
                                          Tamil Title{" "}
                                          <span className="text-danger">*</span>
                                        </Label>
                                        <CustomTamilInput
                                          value={formrow.tamil_title}
                                          name={"tamil_title"}
                                          setValue={e =>
                                            setTab2({...tab2,points:tab2.points.map((d, l) => {
                                                if(l == key){
                                                    return {...d, tamil_title:e};
                                                }
                                                return d;
                                            })})    
                                          }
                                        />
                                      </div>
                                    </Col>
                                    <Col sm="2" className="d-flex align-items-end">
                                        <input type="button" 
                                            className="btn btn-danger mb-3 w-100"
                                            value={'Delete'}
                                            onClick={() => setTab2((p) => ({...p, points : p.points.filter((e,r) => r != key)}))}
                                        />
                                    </Col>
                                  </Row>
                                ))
                              }
                               <Col>
                                <input type="button" 
                                    className="btn btn-success mt-2"
                                    value={'Add Points'}
                                    onClick={() => setTab2((p) => ({...p, points : [...p.points, {eng_title:"", tamil_title:""}]}))}
                                />
                               </Col>
                            </Form>
                          </div>
                        </TabPane>

                        <TabPane tabId={3}>
                          <div>
                            {/* <div className="d-flex justify-content-end w-100">
                                <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                    setshow((p) => {
                                        const h = [...p];
                                        h[2] = !h[2];
                                        return h;
                                    })
                                }}>{show[2] ? "Show" : 'Hidden'}</button>
                            </div> */}

                            <Form>
                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-eng-input5">
                                      English Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      type="text"
                                      name="eng_title"
                                      onChange={handleTab3Change}
                                      className="form-control"
                                      id="basicpill-eng-input5"
                                      placeholder="Enter English Title."
                                      value={tab3?.eng_title}
                                    />
                                  </div>
                                </Col>

                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-hgsd-input6">
                                      Tamil Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <CustomTamilInput
                                      value={tab3.tamil_title}
                                      name={"tamil_title"}
                                      setValue={e =>
                                        setTab3(p => ({ ...p, tamil_title: e }))
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col lg="6">
                                    <div className="mb-3">
                                    <Label for="imag">
                                        Image
                                    <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                        type="file"
                                        onChange={e =>
                                        setTab3(p => ({
                                            ...p,
                                            image_path: e.target.files[0],
                                        }))
                                        }
                                        className="form-control"
                                        id="imag"
                                    />
                                    </div>

                                    {tab3?.image_path && (
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => {
                                        getImg(tab3?.image_path)
                                        }}
                                    >
                                        Preview
                                    </button>
                                    )}
                                </Col>
                              </Row>

                              <h6 className="mb-3 mt-3 card-title">POINTS</h6>
                              {
                                tab3.points?.map((formrow, key) =>  (
                                 <Row key={key}>
                                    <Col lg="5">
                                      <div className="mb-3">
                                        <Label for="basicpill-eng-input5">
                                          English Title{" "}
                                          <span className="text-danger">*</span>
                                        </Label>
                                        <Input
                                          type="text"
                                          name="eng_title"
                                          onChange={(e) =>{
                                            setTab3({...tab3,points:tab3.points.map((d, l) => {
                                                if(l == key){
                                                   return {...d, eng_title:e.target.value};
                                                }
                                                return d;
                                            })})
                                          }}
                                          className="form-control"
                                          id="basicpill-eng-input5"
                                          placeholder="Enter English Title."
                                          value={formrow?.eng_title}
                                        />
                                      </div>
                                    </Col>
    
                                    <Col lg="5">
                                      <div className="mb-3">
                                        <Label for="basicpill-hgsd-input6">
                                          Tamil Title{" "}
                                          <span className="text-danger">*</span>
                                        </Label>
                                        <CustomTamilInput
                                          value={formrow.tamil_title}
                                          name={"tamil_title"}
                                          setValue={e =>
                                            setTab3({...tab3,points:tab3.points.map((d, l) => {
                                                if(l == key){
                                                    return {...d, tamil_title:e};
                                                }
                                                return d;
                                            })})    
                                          }
                                        />
                                      </div>
                                    </Col>
                                    <Col sm="2" className="d-flex align-items-end">
                                        <input type="button" 
                                            className="btn btn-danger mb-3 w-100"
                                            value={'Delete'}
                                            onClick={() => setTab3((p) => ({...p, points : p.points.filter((e,r) => r != key)}))}
                                        />
                                    </Col>
                                  </Row>
                                ))
                              }
                               <Col>
                                <input type="button" 
                                    className="btn btn-success mt-2"
                                    value={'Add Points'}
                                    onClick={() => setTab3((p) => ({...p, points : [...p.points, {eng_title:"", tamil_title:""}]}))}
                                />
                               </Col>
                            </Form>
                          </div>
                        </TabPane>

                        <TabPane tabId={4}>
                          <div>
                            {/* <div className="d-flex justify-content-end w-100">
                                    <button type="button" className="btn btn-primary ms-1 ffjff" onClick={() => {
                                        setshow((p) => {
                                            const h = [...p];
                                            h[3] = !h[3];
                                            return h;
                                        })
                                    }}>{show[3] ? "Show" : 'Hidden'}</button>

                                </div> */}

                           <Form>
                              <Row>
                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-eng-input5">
                                      English Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                      type="text"
                                      name="eng_title"
                                      onChange={handleTab4Change}
                                      className="form-control"
                                      id="basicpill-eng-input5"
                                      placeholder="Enter English Title."
                                      value={tab4?.eng_title}
                                    />
                                  </div>
                                </Col>

                                <Col lg="6">
                                  <div className="mb-3">
                                    <Label for="basicpill-hgsd-input6">
                                      Tamil Title{" "}
                                      <span className="text-danger">*</span>
                                    </Label>
                                    <CustomTamilInput
                                      value={tab4.tamil_title}
                                      name={"tamil_title"}
                                      setValue={e =>
                                        setTab4(p => ({ ...p, tamil_title: e }))
                                      }
                                    />
                                  </div>
                                </Col>
                              </Row>

                              <Row>
                                <Col lg="6">
                                    <div className="mb-3">
                                    <Label for="imag">
                                     Image
                                    <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                        type="file"
                                        onChange={e =>
                                        setTab4(p => ({
                                            ...p,
                                            image_path: e.target.files[0],
                                        }))
                                        }
                                        className="form-control"
                                        id="imag"
                                    />
                                    </div>

                                    {tab4?.image_path && (
                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => {
                                        getImg(tab4?.image_path)
                                        }}
                                    >
                                        Preview
                                    </button>
                                    )}
                                </Col>
                              </Row>

                              <h6 className="mb-3 mt-3 card-title">POINTS</h6>
                              {
                                tab4.points?.map((formrow, key) =>  (
                                 <Row key={key}>
                                    <Col lg="5">
                                      <div className="mb-3">
                                        <Label for="basicpill-eng-input5">
                                          English Title{" "}
                                          <span className="text-danger">*</span>
                                        </Label>
                                        <Input
                                          type="text"
                                          name="eng_title"
                                          onChange={(e) =>{
                                            setTab4({...tab4,points:tab4.points.map((d, l) => {
                                                if(l == key){
                                                   return {...d, eng_title:e.target.value};
                                                }
                                                return d;
                                            })})
                                          }}
                                          className="form-control"
                                          id="basicpill-eng-input5"
                                          placeholder="Enter English Title."
                                          value={formrow?.eng_title}
                                        />
                                      </div>
                                    </Col>
    
                                    <Col lg="5">
                                      <div className="mb-3">
                                        <Label for="basicpill-hgsd-input6">
                                          Tamil Title{" "}
                                          <span className="text-danger">*</span>
                                        </Label>
                                        <CustomTamilInput
                                          value={formrow.tamil_title}
                                          name={"tamil_title"}
                                          setValue={e =>
                                            setTab4({...tab4,points:tab4.points.map((d, l) => {
                                                if(l == key){
                                                    return {...d, tamil_title:e};
                                                }
                                                return d;
                                            })})    
                                          }
                                        />
                                      </div>
                                    </Col>
                                    <Col sm="2" className="d-flex align-items-end">
                                        <input type="button" 
                                            className="btn btn-danger mb-3 w-100"
                                            value={'Delete'}
                                            onClick={() => setTab4((p) => ({...p, points : p.points.filter((e,r) => r != key)}))}
                                        />
                                    </Col>
                                  </Row>
                                ))
                              }
                               <Col>
                                <input type="button" 
                                    className="btn btn-success mt-2"
                                    value={'Add Points'}
                                    onClick={() => setTab4((p) => ({...p, points : [...p.points, {eng_title:"", tamil_title:""}]}))}
                                />
                               </Col>
                            </Form>

                            <h6 className="mb-3 mt-3 card-title">
                              CONCLUTION 
                            </h6>

                            <Row>
                                <Col lg="6">
                                <div className="mb-3">
                                    <Label for="basicpill-firstname-input1">
                                        English Name{" "}
                                    <span className="text-danger">*</span>
                                    </Label>
                                    <Input
                                    type="text"
                                    name="eng_intro"
                                    onChange={handleTab4Change}
                                    value={tab4?.eng_intro}
                                    className="form-control"
                                    id="basicpill-firstname-input1"
                                    placeholder="Enter English Title"
                                    />
                                </div>
                                </Col>

                                <Col lg="6">
                                <div className="mb-3">
                                    <Label for="basicpill-lastname-input2">
                                        Tamil Name{" "}
                                    <span className="text-danger">*</span>
                                    </Label>
                                    <CustomTamilInput
                                    value={tab4.tamil_intro}
                                    setValue={e =>
                                        setTab4(p => ({ ...p, tamil_intro: e }))
                                    }
                                    />
                                </div>
                                </Col>
                            </Row> 

                          </div>
                        </TabPane>
                      </TabContent>
                    </div>

                    <div className="actions clearfix">
                      <ul>
                        <li
                          className={
                            activeTab === 1 ? "previous disabled" : "previous"
                          }
                        >
                          <button
                            onClick={() => {
                              toggleTab(activeTab - 1)
                            }}
                          >
                            Previous
                          </button>
                        </li>
                        <li
                          className={activeTab === 4 ? "next" : "next"}
                        >
                          {activeTab === 4 ? (
                            <button
                              type="button"
                              onClick={() => handleSubmitForm()}
                              className="btn btn-primary"
                            >
                              {isLoading ? (
                                <>
                                  <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                  Loading
                                </>
                              ) : (
                                "Submit"
                              )}
                            </button>
                          ) : (
                            <button
                              onClick={() => {
                                if (activeTab == 1) {
                                  if (!show[0] || handleTab1Verify()) {
                                    toggleTab(activeTab + 1)
                                  }
                                } else if (activeTab == 2) {
                                  if (!show[1] || handleTab2Verify()) {
                                    toggleTab(activeTab + 1)
                                  }
                                } else if (activeTab == 3) {
                                  if (!show[2] || handleTab3Verify()) {
                                    toggleTab(activeTab + 1)
                                  }
                                } else if (activeTab == 4) {
                                  if (!show[0] || handleTab4Verify()) {
                                    toggleTab(activeTab + 1)
                                  }
                                }
                              }}
                            >
                              Next
                            </button>
                          )}
                        </li>
                      </ul>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default withRouter(BlogForm)
